import loadable from "~/common/utils/loadable";
import LoadingIndicator from "~/common/components/LoadingIndicator";

export const CameraPresetListsLoadable = loadable(
  () => import("./CameraPresetListsPage"),
  {
    fallback: <LoadingIndicator />
  }
);
